import { FloatingButtons as SharedFloatingButtons } from '@modules/OrderPreparation/shared';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

export const FloatingButtons = () => {
  const { t } = useTranslation('packingModule');
  const navigate = useNavigate();
  const { id } = useParams();
  const { hasPermission } = usePermissions();

  // 🎯 Verificar permisos de preparación
  const canPicking = hasPermission('preparations.picking');

  // Handler para el botón de historial
  const handleHistory = () => {
    // TODO: Implementar historial del packing
  };

  // Handler para el botón de ver picking
  const handleViewPicking = () => {
    navigate(`/order-preparation/picking/${id}`);
  };

  return (
    <SharedFloatingButtons
      // onHistoryClick={handleHistory}
      onCustomActionClick={canPicking ? handleViewPicking : undefined}
      customActionLabel={t('floating_buttons.view_picking')}
    />
  );
};
